import { useQuery } from '@tanstack/react-query';

import type {
  OrderListItem,
  OrdersListQueryParam,
  StockListItem,
  StocksListQueryParam,
} from 'app/typings/WelcomeKit/welcomeKit';
import type { PageMetaData } from 'app/typings/pagination';
import { apiRequest } from 'app/utils/request/api';

export const pathStocks =
  '/gateway/hotel-logistics/welcome-kit/hotel-stocks' as const;

export const pathOrders =
  '/gateway/hotel-logistics/welcome-kit/orders' as const;

export function useGetStocksList(queryParams: StocksListQueryParam) {
  const { data, isLoading } = useQuery({
    queryKey: [pathStocks, { queryParams }],
    queryFn: () =>
      apiRequest({
        path: pathStocks,
        queryParams,
      }) as Promise<{ data: StockListItem[]; meta: PageMetaData }>,
    keepPreviousData: true,
  });

  return {
    data,
    isLoading,
  };
}

export function useGetOrderList(queryParams: OrdersListQueryParam) {
  const { data, isLoading } = useQuery({
    queryKey: [pathOrders, { queryParams }],
    queryFn: () =>
      apiRequest({
        path: pathOrders,
        queryParams,
      }) as Promise<OrderListItem[]>,
  });

  return {
    data,
    isLoading,
  };
}
